<template>
    <section class="mt-12 scroll-mt-24" id="related-products">
        <h3 class="text-3xl font-semibold">{{ $t('Related products') }}</h3>
        <div class="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-6">
            <template v-for="item in relatedProducts">
                <ProductItem :item="item" :productContextQuery="productContextQuery" />
            </template>
        </div>
    </section>
</template>

<script setup>
import { useRoute } from 'vue-router'
import { pickProductContextQuery } from '@/composables/searchQuery'

defineProps({
    relatedProducts: {
        type: Array,
        required: false,
        default: () => []
    }
})

const route = useRoute()
const productContextQuery = computed(() => pickProductContextQuery(route.query))
</script>
